import { gsap } from 'gsap';

import { Draggable } from 'gsap/Draggable';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin({
    name: 'gsap',
    parallel: true,
    async setup() {
        if (import.meta.client || import.meta.browser) {
            gsap.registerPlugin(
                Draggable
            );
        }
        return {
            provide: {
                gsap,
                Draggable
            }
        };
    }
});
